import { Get } from "domain/infra/data/api";
import DomainConstants from "../../infra/data/domainConstants";
import { ParceiroResponse } from "../../types/parceiro/parceiroResponse";


export class ParceiroService {// extends ExemploService {
  constructor() {
    //super()
  }

  async GetByUrl(url: string): Promise<ParceiroResponse | Error> {
    return await Get(`${DomainConstants.apiDomain.parceiro.getByUrl}?url=${url}`)
  }
}